const features = [
  {
    icon: 'ri-vip-crown-line',
    title: 'Marques Premium',
    description: 'Geberit, Hansgrohe, Grohe, Villeroy &amp; Boch, Kaldewei — les meilleures marques européennes pour votre salle de bain.',
    stat: 'Top 5',
    statLabel: 'Marques EU',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Étanchéité Garantie',
    description: 'Tests d\'étanchéité systématiques, matériaux certifiés, installation selon les normes SIA. Garantie complète sur nos travaux.',
    stat: '100%',
    statLabel: 'Testé',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Finitions Soignées',
    description: 'Attention portée aux détails, joints parfaits, alignements précis. Résultat esthétique et durable pour votre satisfaction.',
    stat: '★★★★★',
    statLabel: 'Qualité',
  },
  {
    icon: 'ri-time-line',
    title: 'Respect des Délais',
    description: 'Planning précis, coordination optimale, chantier propre. Nous respectons nos engagements et vos contraintes de temps.',
    stat: '98%',
    statLabel: 'Dans les délais',
  },
];

export default function SanitaireFeatures() {
  return (
    <section className="py-20 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/25 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-water-flash-line text-amber-400 text-sm"></i>
              <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Nos Engagements</span>
            </div>
            <h2 className="text-3xl font-bold text-white sm:text-4xl">
              Pourquoi choisir nos<br />
              <span className="text-amber-400">installations sanitaires</span>
            </h2>
          </div>
          <p className="text-gray-400 text-sm max-w-sm leading-relaxed">
            Qualité, expertise et service pour vos projets sanitaires à Genève et en Suisse romande.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-gray-900 rounded-2xl p-6 border border-white/5 hover:border-amber-500/30 transition-all group">
              <div className="flex items-start justify-between mb-5">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-500/15 border border-amber-500/30 rounded-xl group-hover:bg-amber-500 group-hover:border-amber-500 transition-all">
                  <i className={`${f.icon} text-amber-400 group-hover:text-white transition-colors`}></i>
                </div>
                <div className="text-right">
                  <div className="text-base font-bold text-amber-400">{f.stat}</div>
                  <div className="text-xs text-gray-500">{f.statLabel}</div>
                </div>
              </div>
              <h3 className="text-sm font-bold text-white mb-2">{f.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed" dangerouslySetInnerHTML={{ __html: f.description }}></p>
            </div>
          ))}
        </div>

        {/* Banner */}
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-6 bg-amber-500/8 border border-amber-500/20 rounded-2xl px-8 py-6">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-xl shrink-0">
            <i className="ri-drop-line text-white text-xl"></i>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-base font-bold text-white mb-1">Installation professionnelle avec étanchéité garantie</h3>
            <p className="text-gray-400 text-sm">Dépose, installation, raccordements eau et évacuation, tests d'étanchéité, nettoyage du chantier. Garantie installation 2 ans.</p>
          </div>
          <a href="#contact" className="shrink-0 inline-flex items-center gap-2 rounded-lg bg-amber-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer">
            Demander un devis
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
